function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var TreeNode = /*#__PURE__*/function () {
  function TreeNode(_ref) {
    var id = _ref.id,
      name = _ref.name;
    _classCallCheck(this, TreeNode);
    _defineProperty(this, "id", void 0);
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "parentNode", void 0);
    _defineProperty(this, "childNodes", []);
    this.id = id.toString();
    this.name = name;
  }
  _createClass(TreeNode, [{
    key: "parentNodes",
    get: function get() {
      var parentNodes = [];
      if (this.parentNode) {
        parentNodes.push.apply(parentNodes, [].concat(_toConsumableArray(this.parentNode.parentNodes), [this.parentNode]));
      }
      return parentNodes;
    }
  }, {
    key: "brotherNodes",
    get: function get() {
      var _this = this;
      //eslint-disable-next-line eqeqeq
      return this.parentNode ?
      //eslint-disable-next-line eqeqeq
      this.parentNode.childNodes.filter(function (item) {
        return item.id != _this.id;
      }) : [];
    }
  }, {
    key: "flattenChildNodes",
    get: function get() {
      var flattenChildNodes = [];
      this.childNodes.forEach(function (childNode) {
        flattenChildNodes.push.apply(flattenChildNodes, [childNode].concat(_toConsumableArray(childNode.flattenChildNodes)));
      });
      return flattenChildNodes;
    }
  }, {
    key: "key",
    get: function get() {
      return this.id.toString();
    }
  }, {
    key: "completeName",
    get: function get() {
      return "".concat(this.parentNode ? "".concat(this.parentNode.completeName, "-") : '').concat(this.name);
    }
  }, {
    key: "hasChildren",
    get: function get() {
      return this.childNodes.length !== 0;
    }
  }, {
    key: "treeData",
    get: function get() {
      return {
        key: this.id,
        title: this.name,
        children: this.childNodes.map(function (childNode) {
          return childNode.treeData;
        })
      };
    }
  }, {
    key: "setParent",
    value: function setParent(parentNode) {
      this.parentNode = parentNode;
    }
  }, {
    key: "setChildren",
    value: function setChildren(childNodes) {
      this.childNodes = childNodes;
    }
  }]);
  return TreeNode;
}();
export var DataTree = /*#__PURE__*/function () {
  function DataTree(nodes, isFilterDisabled) {
    var _this2 = this;
    _classCallCheck(this, DataTree);
    _defineProperty(this, "nodes", []);
    _defineProperty(this, "nodesMap", new Map());
    var traverse = function traverse(tempNodes, parentNode) {
      return (isFilterDisabled ? tempNodes.filter(function (it) {
        return it.enabled;
      }) : tempNodes).map(function (node) {
        var treeNode = new TreeNode(node);
        if (parentNode) {
          treeNode.setParent(parentNode);
        }
        _this2.nodesMap.set(treeNode.id, treeNode);
        if (node.children) {
          treeNode.setChildren(traverse(node.children, treeNode));
        }
        return treeNode;
      });
    };
    this.nodes = traverse(nodes);
  }
  _createClass(DataTree, [{
    key: "data",
    get: function get() {
      return this.nodes.map(function (node) {
        return node.treeData;
      });
    }
  }, {
    key: "getNodesById",
    value: function getNodesById(id) {
      return _toConsumableArray(this.nodesMap.values()).filter(function (node) {
        return node.id === id;
      });
    }
  }, {
    key: "getNode",
    value: function getNode(key) {
      return this.nodesMap.get(key);
    }
  }]);
  return DataTree;
}();